import { useEffect, useState } from "react";

const useResizeObserver = (
  targetRef: React.RefObject<HTMLElement>,
  callback?: (rect: DOMRect) => void
) => {
  const [rect, setRect] = useState<DOMRect>();

  useEffect(() => {
    if (!targetRef.current) return;

    const observer = new ResizeObserver(() => {
      if (targetRef.current) {
        const rectData = targetRef.current.getBoundingClientRect();
        callback?.(rectData);
        setRect(rectData);
      }
    });
    observer.observe(targetRef.current);
    return () => {
      if (targetRef.current) observer.unobserve(targetRef.current);
    };
  }, [targetRef]);

  return { rect };
};

export default useResizeObserver;
